import { render } from "./Ma_CouponCreate.vue?vue&type=template&id=37e6cb55&scoped=true"
import script from "./Ma_CouponCreate.vue?vue&type=script&lang=js"
export * from "./Ma_CouponCreate.vue?vue&type=script&lang=js"

import "./Ma_CouponCreate.vue?vue&type=style&index=0&id=37e6cb55&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e6cb55"]])

export default __exports__